module.exports = __webpack_public_path__ + "static/media/person-highlight.fadd06b3.png";